import fetchProductCatNavFilters from "@faire/web-api/api/v2/search/products/cat-nav/filters/post";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useLoggedOutCategoryPageCatNavRequest } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/__internal__/useLoggedOutCategoryPageCatNavRequest";

export const useLoggedOutCategoryPageFilterSections = () => {
  const request = useLoggedOutCategoryPageCatNavRequest();

  const { data, isFetching } = useQuery({
    // TODO: (Alier): this is to avoid calling the endpoint twice as fetchPageData (pagesize) changes once banners call finishes
    // We can switch to use getQueryKey when we finish make brand value banner size static
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      request.filter_keys,
      request.navigation_path,
      request.pagination_data?.page_number,
    ],
    queryFn: () => fetchProductCatNavFilters(request),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
  return {
    data: {
      filterSections: data?.filter_sections ?? [],
    },
    isFetching,
  };
};
